import React from "react";

export function withStopPropagation<
  T extends React.MouseEvent | React.TouchEvent,
>(cb?: (event: T) => void) {
  return (event: T) => {
    event.stopPropagation();
    cb?.(event);
  };
}
